export default class WinWindow {
  constructor(view) {
    this.view = view;
    this.view.visible = false;
  }

  show(win) {
    this.view.txt.text = win ? `Вы выиграли: ${win} G` : 'Нет выигрыша';
    return new Promise(resolve => createjs.Tween.get(this.view, { override: true })
      .to({ visible: true })
      .to({ scaleX: 1, scaleY: 1 }, 200)
      .to({ scaleX: 1.3, scaleY: 1.3 }, 180)
      .to({ scaleX: 1, scaleY: 1 }, 180)
      .call(resolve)
      .wait(1000)
      .call(() => !win && this.hide()));
  }

  hide() {
    return new Promise(resolve =>
      createjs.Tween.get(this.view, { override: true })
        .to({ visible: false, scaleX: 0, scaleY: 0 }, 300)
        .call(resolve));
  }
}



// WEBPACK FOOTER //
// ../base/js/display/WinWindow.js